class BundlerBuilder extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.BUNDLE_VARIANT_ID = this.getAttribute("data-bundle-variant-id");
    this.navigation = this.querySelector(".bundler-builder--navigation");

    this.addToCartBtn = this.navigation.querySelector(
      "button[data-add-bundle-to-cart]"
    );

    this.productsGrid = this.querySelector(".bundler-builder--grid");

    this.productsGrid.addEventListener(
      "input",
      this.productsGridInputEventHandler.bind(this)
    );

    this.navigation.addEventListener(
      "click",
      this.navigationEventHandler.bind(this)
    );
  }

  disconnectedCallback() {
    this.productsGrid.removeEventListener(
      "input",
      this.productsGridInputEventHandler.bind(this)
    );
    this.navigation.removeEventListener(
      "click",
      this.navigationEventHandler.bind(this)
    );
  }

  productsGridInputEventHandler(event) {
    const input = event.target.closest(`input[type="checkbox"]`);
    if (!input) return;

    const label = input.nextElementSibling;
    const productImg = label.querySelector("img");
    const productImgClone = productImg.cloneNode(true);

    if (this.checkBundleSize() > 5) {
      input.checked = false;
      return;
    }

    if (input.checked) {
      this.setProductImageInNavItem(productImgClone, input.value);
    } else {
      this.removeProductFromNavigation(input.value);
    }

    this.setDisabledAddToCartBtn();
  }

  navigationEventHandler(event) {
    const navItem = event.target.closest(".bundler-builder--nav-item");
    const button = event.target.closest("[data-add-bundle-to-cart]");

    if (navItem) {
      const { navItemProdId } = navItem.dataset;
      this.removeProductFromNavigation(navItemProdId);
      this.removeCheckedProduct(navItemProdId);
    }

    if (button) {
      this.addToCart();
    }
  }

  setProductImageInNavItem(imgElement, productId) {
    const emptyNavItem = this.getEmptyNavItem();
    if (!emptyNavItem) return;

    emptyNavItem.appendChild(imgElement);
    emptyNavItem.dataset.navItemProdId = productId;
    emptyNavItem.dataset.navItemHasContent = true;
  }

  async addToCart() {
    const productIds = this.getProductsIds();
    if (productIds.length !== 5) {
      console.error("The bundle must contain exactly 5 items.");
      return;
    }

    const bundleDetails = this.getBundleDetails();
    if (bundleDetails.length !== productIds.length) {
      console.error("Unable to build bundle details for all selections.");
      return;
    }

    this.setLoadingStateAddToCartBtn(true);

    try {
      const propTimeStamp = Date.now();

      // Build the properties object with "_bundle_item_1" to "_bundle_item_5"
      const properties = {
        _bundle_name: "build_your_own_bundle",
        _bundle_timestamp: propTimeStamp,
        _bundle_product_builder: bundleDetails,
      };

      productIds.forEach((productId, index) => {
        properties[
          `_bundle_item_${index + 1}`
        ] = `gid://shopify/ProductVariant/${productId}`;
      });

      const formData = {
        items: [
          {
            id: this.BUNDLE_VARIANT_ID,
            quantity: 1,
            properties: properties,
          },
        ],
      };

      await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
    } catch (error) {
      console.error(`Bundler Build | addToCart | ${error}`);
    } finally {
      this.setLoadingStateAddToCartBtn(false);
      this.resetElements();
    }
  }

  getEmptyNavItem() {
    return this.navigation.querySelector(
      `.bundler-builder--nav-item[data-nav-item-has-content="false"]`
    );
  }

  removeProductFromNavigation(productId) {
    const navItem = this.navigation.querySelector(
      `.bundler-builder--nav-item[data-nav-item-prod-id="${productId}"]`
    );
    if (!navItem) return;

    navItem.dataset.navItemHasContent = false;
    navItem.dataset.navItemProdId = "";
    navItem.innerHTML = "";
  }

  removeCheckedProduct(productId) {
    this.productsGrid.querySelector(
      `input[type="checkbox"][value="${productId}"]`
    ).checked = false;
  }

  setDisabledAddToCartBtn() {
    const checkedProducts = this.checkBundleSize();
    this.addToCartBtn.disabled = checkedProducts < 5;
    this.addToCartBtn.innerHTML = `${
      checkedProducts < 5 ? "ADD MORE" : "ADD TO BAG"
    }`;
  }

  setLoadingStateAddToCartBtn(flag) {
    this.addToCartBtn.disabled = flag;
  }

  checkBundleSize() {
    return this.productsGrid.querySelectorAll(`input[type="checkbox"]:checked`)
      .length;
  }

  getProductsIds() {
    return Array.from(
      this.navigation.querySelectorAll(
        `.bundler-builder--nav-item[data-nav-item-has-content="true"]`
      )
    )
      .map((el) => el.dataset.navItemProdId)
      .filter(Boolean);
  }

  getBundleDetails() {
    // Build a human-readable descriptor for each selection to fuel the Rebuy cart template
    return Array.from(
      this.navigation.querySelectorAll(
        `.bundler-builder--nav-item[data-nav-item-has-content="true"]`
      )
    )
      .map((navItem) => {
        const productId = navItem.dataset.navItemProdId;
        if (!productId) return "";

        const checkbox = this.productsGrid.querySelector(
          `input[type="checkbox"][value="${productId}"]`
        );
        if (!checkbox) return "";

        const label = checkbox.nextElementSibling;
        if (!label) return "";

        const title = label.querySelector("p strong")?.textContent.trim();

        const detailParts = [];
        if (title) detailParts.push(title);

        return detailParts.join(" | ");
      })
      .filter(Boolean);
  }

  resetElements() {
    this.navigation
      .querySelectorAll(".bundler-builder--nav-item")
      .forEach((el) => {
        el.dataset.navItemProdId = "";
        el.dataset.navItemHasContent = false;
        el.innerHTML = "";
      });

    this.productsGrid
      .querySelectorAll(".bundler-builder--grid-item input[type='checkbox']")
      .forEach((el) => {
        el.checked = false;
      });
  }
}
customElements.define("bundler-builder", BundlerBuilder);
